import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const crossEntropyComponent: ComponentDef = {
  id: 'cross-entropy',
  name: 'Cross Entropy Loss',
  description: 'Classification loss from logits and target class indices.',
  category: 'function',
  params: [
    { name: 'batch_size', label: 'Batch size', type: 'number', default: 32, min: 1, max: 4096, step: 1 },
    { name: 'num_classes', label: 'Classes', type: 'number', default: 1000, min: 2, max: 100000, step: 1 },
    { name: 'variant', label: 'Variant', type: 'select', default: 'standard', options: [{ label: 'Standard', value: 'standard' }, { label: 'Label Smoothing', value: 'label_smoothing' }] }
  ],
  buildGraph: (params) => {
    const batch_size = Number(params.batch_size);
    const num_classes = Number(params.num_classes);
    const variant = params.variant;
    const g = new GraphBuilder();
    g.input('logits', [batch_size, num_classes]);
    g.input('targets', [batch_size]);

    if (variant === 'label_smoothing') {
      g.scale('smooth_targets', 'targets', 'smooth');
      g.softmax('log_probs', 'logits', -1);
      g.crossEntropy('loss', 'log_probs', 'smooth_targets');
    } else {
      g.crossEntropy('loss', 'logits', 'targets');
    }

    g.output('out', 'loss');
    return g.build();
  }
};
